import styled from "styled-components";

import { breakpoints, semiBoldAlias } from "Libs/theme";

export const BREAKPOINT = `(min-width: ${breakpoints[1]})`;

export const Sidebar = styled.div`
  background-color: var(--section-snow-background-color, var(--snow));
  width: 272px;
  min-width: 200px;
  margin-left: -40px;
  padding: 16px 32px 16px 40px;
  min-height: calc(100vh - 115px);

  @media (min-width: 1940px) {
    padding-left: 60px;
  }
`;

export const MenuTriggerContainer = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  position: relative;
  z-index: 10;

  h3 {
    margin: 0;
  }

  @media ${BREAKPOINT} {
    z-index: 1;
    h3 {
      margin-bottom: 18px;
    }
  }
`;

export const MobileMenuContainer = styled.div`
  margin-top: 16px;
  z-index: 6;
`;

export const ExpandedMobileMenu = styled.div`
  background-color: var(--section-snow-background-color, var(--snow));
  position: absolute;
  left: 0;
  right: 0;
  top: 70px;
  bottom: 0;
  padding-top: 114px;
`;

export const Submenu = styled.ul`
  color: var(--link-slate-color, var(--slate));
  list-style: none;
  margin: 0;
  padding: 0;
  padding-bottom: 16px;
  line-height: 2.5;
`;

export const MenuHeader = styled.button`
  background: transparent;
  color: var(--color);
  border: none;
  display: inline-block;
  display: flex;
  width: 100%;
  margin: 0;
  padding: 4px 0;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;

  h1 {
    font-size: 14px;
    ${semiBoldAlias()};
  }
`;

export const MenuChildrenContainer = styled.section`
  --color: ${props =>
    props.expanded
      ? "var(--link-color-primary-600-color,var(--color-primary-600))"
      : "var(--link-slate-color,var(--slate))"};
  --border-color: ${props =>
    props.expanded
      ? "var(--link-color-primary-600-border-color,var(--color-primary-600))"
      : "var(--link-periwinkle-grey-border-color,var(--periwinkle-grey))"};
  border-top: 1px solid var(--border-color);
  margin: 0 24px;
  font-size: 14px;
  ${semiBoldAlias()};
  color: var(--color);

  a {
    ${semiBoldAlias()};
  }

  @media ${BREAKPOINT} {
    margin: 0;
  }
`;
